module.exports = __webpack_public_path__ + "static/img/sl.e27e972.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sl.png
// module id = IIwu
// module chunks = 1